const adminInfoStorage = {
  namespaced: true,

  state: {
    adminInfo: []
  },
  getters: {
   getAdminInfo(state) {
      return state.adminInfo
   }
  },
  mutations: {
    updateAdminInfo(state, info) {
      state.adminInfo = {
        'studentId': info.studentId,
        'parentId': info.parentId,
        'entry': info.entry
      }
    }
  },
};
export default adminInfoStorage